import { useState } from 'react';

export const useModal = (initialOpen: boolean) => {
  const [open, setIsOpen] = useState(initialOpen);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return { open, openModal, closeModal };
};
